var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-btn-wrapper"},_vm._l((_vm.data.optionList),function(i){return _c('span',{key:i.id,staticClass:"c-btn-wrapper-items textEllipsis",style:(_vm.getStyle(i)),attrs:{"title":i.optionName},on:{"click":function($event){return _vm.handleClick(i)}}},[_vm._v("\n    "+_vm._s(i.optionName)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84dd29c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cashier/components/cashierdiaryTable/attr/c-btn.vue
// module id = null
// module chunks = 